import {isPlayerPolicy} from "../../factions/isPlayerPolicy";
import {POLICIES} from "../../../constants/policies";

export const checkIfCouldManeuverFromHex = (owner, hexes, hexKey) => {
  if (isPlayerPolicy(owner, POLICIES.ECOANARCHISM)) {
    return true;
  }

  const token = hexes[hexKey];

  return !!token;
}